import React, { useContext, useMemo } from 'react';

import { makeStyles } from '@mui/styles';
import { Avatar, Tooltip } from '@mui/material';
import { Box, Grid, Paper, Typography } from '@mui/material';
import { PatientTabsContext } from '../../../lib/contexts';
import useMetric from '../../../lib/hooks/useMetric';
import { AdminProgressBar } from '../../../components/AdminProgressBar';
import { AdminChip } from '../../../components/AdminChip';
import { Add } from '@mui/icons-material';
import { getInitials } from '../../../lib/helpers/helpers';

const useStyles = makeStyles((theme) => ({
  patientChartCard: theme.globalClasses.patientChartCard,
  container: {
    maxHeight: 120,
    overflowY: 'scroll',
    display: 'flex',
    flexDirection: 'row',
    gap: 5,
  },
  topBar: {
    // marginBottom:10
  },
  addList: {
    fontSize: 18,
    marginBottom: -5,
    fontWeight: 'bold',
  },
}));

const PatientAssociatedAdminsBox = () => {
  const classes = useStyles();
  const {
    state: { currentTab },
  } = useContext(PatientTabsContext);
  const { isLoading, data } = useMetric('associated_admins', currentTab.id);
  // console.log('here is the data from patientassociatedadminsbox', data?.metric?.value[0]?.name);
  return (
    <Grid
      item
      xs={12}
    >
      <Paper className={classes.patientChartCard}>
        <Typography
          variant={'h2'}
          className={classes.topBar}
        >
          Associated Admins
        </Typography>
        {isLoading ? (
          <AdminProgressBar />
        ) : (
          <Box
            className={classes.container}
            sx={{
              display: 'flex',
              flexDirection: 'row',
              flexWrap: 'wrap',
              gap: 2,
              justifyContent: 'flex-start',
              '& > *': {
                width: '60px',
                height: '60px',
                borderRadius: '50%',
              },
            }}
          >
            {data &&
              data.metric &&
              data.metric.value.map((item, index) => (
                <Tooltip
                  key={index}
                  title={item.name}
                >
                  <Avatar
                    key={index}
                    sx={{
                      bgcolor: 'primary.main',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      maxWidth: '37px',
                      maxHeight: '37px',
                    }}
                  >
                    {getInitials(item.name)}
                  </Avatar>
                </Tooltip>
              ))}
            <AdminChip
              disabled={true}
              label={
                <>
                  <Add className={classes.addList} />
                  &nbsp;Add
                </>
              }
              clickable
              onClick={() => {}}
            />
          </Box>
        )}
      </Paper>
    </Grid>
  );
};

export default PatientAssociatedAdminsBox;
